import styled from 'styled-components';

const Notice = styled.div`
  font-size: 12px;
  color: var(--text-grey);
  padding: 30px 5px 20px 5px;
`;

export default Notice;
